package dev.lingvo.site.ds

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Hr

val LDividerStyle = CssStyle.base {
    Modifier
        .width(100.percent)
        .height(1.px)
        .margin(0.px)
        .backgroundColor(colorMode.toSitePalette().border)
        .styleModifier {
            property("border", "0")
            property("flex-shrink", "0")
        }
}

@Composable
fun LDivider(
    modifier: Modifier = Modifier,
    label: String? = null,
) {
    Hr(
        LDividerStyle.toModifier().then(modifier).toAttrs {
            if (label != null) attr("aria-label", label)
        },
    )
}
